import React, { JSX } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';
import { StyleguideComponentProps } from 'lib/component-props';

type PageNavigationProps = StyleguideComponentProps & {};

const PageNavigation = (props: PageNavigationProps): JSX.Element | null => {
  if (isEditorActive()) {
    return null;
  }

  return (
    <ul
      className="page-navigation gic-page-navigation"
      id={`page-navigation-${props.rendering?.uid}`}
    >
      <li>
        <a aria-label="mammograms" href="Mammograms">
          <div className="list-block">Mammograms</div>
        </a>
      </li>
      <li>
        <a aria-label="safety-protocols" href="safety-protocols">
          <div className="list-block">Safety Protocols</div>
        </a>
      </li>
      <li>
        <a aria-label="patient-stories" href="patient-stories">
          <div className="list-block">Patient Stories</div>
        </a>
      </li>
    </ul>
  );
};

export default PageNavigation;
